import { Grid, Link, View } from "@adobe/react-spectrum";
import { Header } from "components/Header/Header";
import { FC, Suspense, useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router";
import store from "store/store";
import { ViewType, views } from "views/views";

export interface RouteComponentProps {
  RouteObject: ViewType;
}

const RouteComponent: FC<RouteComponentProps> = ({ RouteObject }) => {
  useEffect(() => {
    window.document.title = RouteObject.title;
  }, [RouteObject.title]);

  return <RouteObject.Component {...RouteObject.defaultProps} />;
};

export function App() {
  return (
    <Provider store={store}>
      <HashRouter>
        <Grid
          areas={["header", "mainContent"]}
          UNSAFE_className="content"
          rows={["auto", "1fr"]}
        >
          <Header gridArea="header" />
          <View gridArea="mainContent">
            <Routes>
              {views.map((CurrView) => (
                <Route
                  key={CurrView.id}
                  path={CurrView.path}
                  element={
                    <Suspense fallback={<div>Loading ...</div>}>
                      <RouteComponent RouteObject={CurrView} />
                    </Suspense>
                  }
                />
              ))}
            </Routes>
          </View>
        </Grid>
      </HashRouter>
    </Provider>
  );
}
